export default {
  host: process.env.VUE_APP_API_HOST || 'https://sport-73zoq.ondigitalocean.app',
  clientSiteHost: process.env.VUE_APP_CLIENT_SITE_HOST || 'http://192.168.100.26:1111',
}
